import React from 'react';
import { Box, Typography, Stack, Button } from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import { grey } from '@mui/material/colors';

const CustomChip = ({ icon, action, label, onClick = undefined, isMenu = false }) => {
    return (
        <Box
            sx={{
                borderRadius: 0.25,
                pl: 1,
                pr: 0.5,
                py: 0,
                backgroundColor: grey[200],
                color: grey[800]
            }}
            component={onClick ? Button : undefined}
            onClick={onClick || undefined}
        >
            <Stack
                direction="row"
                spacing={1}
                sx={{
                    alignItems: 'center'
                }}
            >
                {icon}
                <Typography
                    variant="caption"
                    sx={{
                        lineHeight: 1,
                        py: 1,
                        pr: action ? 0 : 0.5
                    }}
                >
                    {label}
                </Typography>
                {isMenu && (
                    <ArrowDropDown
                        fontSize="small"
                        sx={{
                            ml: 1
                        }}
                    />
                )}
                {action}
            </Stack>
        </Box>
    );
};

export default CustomChip;